import { render } from "./PersonalTab.vue?vue&type=template&id=6994ff40"
import script from "./PersonalTab.vue?vue&type=script&lang=js"
export * from "./PersonalTab.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__